import { render, staticRenderFns } from "./WhopperOnboarding.vue?vue&type=template&id=37f81134&scoped=true"
import script from "./WhopperOnboarding.vue?vue&type=script&lang=js"
export * from "./WhopperOnboarding.vue?vue&type=script&lang=js"
import style0 from "./WhopperOnboarding.vue?vue&type=style&index=0&id=37f81134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f81134",
  null
  
)

export default component.exports